import { INICIALIZAR } from '../actions';
export default function configCaminos() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case INICIALIZAR:
      return action.config.configCaminos;

    default:
      return state;
  }
}